<template>
  <li class="sr--li">
    <div class="sr--li_box" @click="clickGo">
      <p class="sr--li_img" v-lazy:background-image="img"></p>
      <div class="sr--li_container">
        <slot></slot>
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    props: {
      img: String,
      go: [String, Number]
    },
    methods: {
      clickGo () {
        this.$emit('click', this.go)
      }
    }
  }
</script>

<style lang="less" scoped>
  .sr--li {
    float: left;
    width: 300px;
    list-style: none;
    padding-bottom: 20px;
    .sr--li_box {
      margin: 0 10px;
      background-color: white;
      border: 1px solid #ededed;
      border-bottom-width: 2px;
      cursor: pointer;
      transition: all .2s linear;
      &:hover {
        box-shadow: 0 8px 18px rgba(0,0,0,.2);
        transform: translate3d(0,-1px,0);
        border-bottom-color: #fbb03b;
      }
    }
    .sr--li_img {
      padding-top: 100%;
      background-position: center;
      background-size: cover;
      background-color: #d8d8d8;
    }
    .sr--li_container {
      margin: 0 1em;
      padding: 10px 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/list/item.vue